import React, { FC } from 'react';
import { Form } from 'antd';
import { WrappedFormUtils } from 'antd/lib/form/Form';
import { Input } from '../../../system/components/Input';

interface Props {
  form: WrappedFormUtils;
  initialValue?: string;
}

export const InputLastName: FC<Props> = ({ form, initialValue }): JSX.Element => (
  <Form.Item label="Last Name:">
    {form.getFieldDecorator('lastName', {
      initialValue,
      rules: [{ required: false }],
    })(<Input allowClear placeholder="Last Name" />)}
  </Form.Item>
);
